const siteMapping = {
    hl: {
        pillarId: 2,
        landingPageId: process.env.QUIZLER_LANDINGPAGE_ID
    },
    mnt: {
        pillarId: 5,
        landingPageId: 407
    }
}

export default siteMapping;